import httpClient from "./httpClient";

const prefix = "/rols";

export async function listAllRoles() {
  return (await httpClient.get(prefix + "/list-all")).data;
}
